import {
    Directive,
    ElementRef,
    Renderer,
    Output,
    EventEmitter,
    Input,
} from '@angular/core';

@Directive({
    selector: '[datepicker-item]',

})
export class DatepickerItemDirective {
    @Output() sendMsgEvent: EventEmitter<Number> = new EventEmitter();
    @Input("month") month: number;
    constructor(private element: ElementRef) { }
    ngOnInit() {

        this.element.nativeElement.addEventListener(
            'click',
            (event) => {

                this.OutMonth(this.month);
                $('.datepicker-fon').fadeOut(100);

                this.UpdateChartVal();
            },
            false
        );
    }
    UpdateChartVal() {
        $('.mask').toggle();
        if (window.scrollY >= 110) return;
        if ((<HTMLElement>document.body.querySelector('.chart-val-two')).style.bottom === '220px') {
            (<HTMLElement>document.body.querySelector('.chart-val-two')).style.bottom = '219px';

        } else {
            (<HTMLElement>document.body.querySelector('.chart-val-two')).style.bottom = '220px';

        }
    }
    OutMonth(month: number) {
        this.sendMsgEvent.emit(month);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/rtb/directives/datepicker-item.directive.ts